<template>
</template>
<script>
export default {
    name: 'Head',
    props: ['meta'],
    data() {
        return {
            //meta: this.$parent.meta
        }
    },
    created: function() {
        let self = this
        window.setTimeout(function() {
            // updating head
            //self.head_title = self.name + ' - Fizykoteka'
            //self.$emit('updateHead')
 
        }, 1)
    },
    watch: {
      $props: {
        immediate: true, 
        deep: true,
        handler(v) {
          //this.$emit('updateHead')
          //this.meta.og_image = meta.og_image
        }
      }
    },
    head: {
        title: function() {
            return {
                inner: this.meta.title
            }
        },
        link: [{
            rel: 'shortcut icon',
            href: require('@/assets/img/favicons/favicon-16x16.png'),
            sizes: "16x16"
        }, {
            rel: 'shortcut icon',
            href: require('@/assets/img/favicons/favicon-32x32.png'),
            sizes: "32x32"
        }, {
            rel: "apple-touch-icon",
            href: require('@/assets/img/favicons/apple-touch-icon.png'),
            sizes: "180x180"
        },
        {
            rel: "android-chrome",
            href: require('@/assets/img/favicons/android-chrome-512x512.png'),
            sizes: "512x512"
        },
        {
            rel: "android-chrome",
            href: require('@/assets/img/favicons/android-chrome-192x192.png'),
            sizes: "192x192"
        }],
        meta: function() {
            // waiting for async data ready
            if (this.meta.title) {
                return [{
                        name: 'description',
                        content: this.meta.description
                    },
                    {
                        property: 'og:url',
                        content: this.meta.url
                    },
                    {
                        property: 'og:type',
                        content: this.meta.og_type
                    },
                    {
                        property: 'og:title',
                        content: this.meta.title
                    },
                    {
                        property: 'og:image',
                        content: this.meta.og_image
                    }
                ]
            }
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Common/Head.vue